import { useState } from "react";
import useRead from "../useRead";
import useCreate from "../useCreate";
import toast from "react-hot-toast";

const usePitchDeckList = () => {
  // Status Logic
  const [pitchDeckStatus, setPitchDeckStatus] = useState(false);
  const [isToggleLoading, setIsToggleLoading] = useState(false);
  const [previousStatus, setPreviousStatus] = useState(false);

  // Header & Script Logic
  const [header, setHeader] = useState("");
  const [initialHeader, setInitialHeader] = useState("");
  const [script, setScript] = useState("");
  const [initialScript, setInitialScript] = useState("");
  const [isUpdating, setIsUpdating] = useState(false);

  // Fetch pitch deck data
  const { data: pitchDeckData, data: refetchPitchDeck } = useRead({
    url: "get-pitch-deck-data",
    method: "GET",
    initialData: {},
    onSuccess: (data) => {
      setPitchDeckStatus(data.pitch_deck_status);
      setHeader(data.header || "");
      setInitialHeader(data.header || "");
      setScript(data.script || "");
      setInitialScript(data.script || "");
    },
    onError: (err) => {
      toast.error(
        err?.response?.data?.message || err?.message || "Failed to fetch Pitch Deck data",
      );
    },
  });

  // Update pitch deck status
  const { setDataToServer: updateStatus } = useCreate({
    url: "change-pitch-deck-status",
    refreshUrl: "get-pitch-deck-data",
    onSuccess: (data) => {},
    onError: (err) => {
      // Revert to previous state on error
      setPitchDeckStatus(previousStatus);
      setIsToggleLoading(false);
      toast.error(
        err?.response?.data?.message ||
          err?.message ||
          "Failed to update Pitch Deck status",
      );
    },
  });

  const handlePitchDeckStatusChange = async (event) => {
    const newStatus = event.target.checked;
    // Store the current status before changing
    setPreviousStatus(pitchDeckStatus);
    setIsToggleLoading(true);
    setPitchDeckStatus(newStatus);

    updateStatus.mutate(
      {
        enable: newStatus,
      },
      {
        onSuccess: () => {
          toast.success(
            `Pitch Deck ${newStatus ? "enabled" : "disabled"} successfully`,
          );
          setIsToggleLoading(false);
        },
        onError: (err) => {
          setPitchDeckStatus(previousStatus);
          setIsToggleLoading(false);
          toast.error(
            err?.response?.data?.message ||
              err?.message ||
              "Failed to update Pitch Deck status",
          );
        },
      },
    );
  };

  // Update Header & Script
  const { setDataToServer: updateData } = useCreate({
    url: "update-pitch-deck-data",
    refreshUrl: "get-pitch-deck-data",
    onSuccess: (data) => {
      toast.success("Pitch Deck data updated successfully");
      setInitialHeader(header);
      setInitialScript(script);
      setIsUpdating(false);
    },
    onError: (err) => {
      setIsUpdating(false);
      toast.error(
        err?.response?.data?.message || err?.message || "Failed to update Pitch Deck data",
      );
    },
  });

  const handleHeaderChange = (e) => {
    setHeader(e.target.value);
  };

  const handleScriptChange = (e) => {
    setScript(e.target.value);
  };

  const handleSaveData = () => {
    setIsUpdating(true);
    updateData.mutate({ header, script });
  };

  const isDataChanged = header !== initialHeader || script !== initialScript;

  return {
    pitchDeckData,
    pitchDeckStatus,
    isToggleLoading,
    handlePitchDeckStatusChange,
    header,
    handleHeaderChange,
    script,
    handleScriptChange,
    handleSaveData,
    isUpdating,
    isDataChanged,
  };
};

export default usePitchDeckList;
